module.exports = __webpack_public_path__ + "source-sans-pro-v11-latin-600italic-b64533f91a44618285bfdde8780fc19d.bundle.woff2";